import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import injectSheet from 'react-jss';
const loadScript = require('load-script');
import ckEditorCss from '../styles/ckEditor';
import { config } from '../../../config';

let CDN_BUNDLE_URL = config.CDN_BUNDLE_URL;
var defaultScriptUrl = `${CDN_BUNDLE_URL}ckeditor/ckeditor.js`;

/**
 * @author codeslayer1
 * @description CKEditor component to render a CKEditor textarea with defined configs and all CKEditor events handler
 */
class CKEditor extends React.Component {
  constructor(props) {
    super(props);

    //Bindings
    this.onLoad = this.onLoad.bind(this);

    //State initialization
    this.state = {
      isScriptLoaded: this.props.isScriptLoaded,
      config: this.props.config
    };
  }

  //load ckeditor script as soon as component mounts if not already loaded
  componentDidMount() {
    if (!this.props.isScriptLoaded) {
      loadScript(this.props.scriptUrl, this.onLoad);
    } else {
      this.onLoad();
    }
  }

  componentWillUnmount() {
    this.unmounting = true;
  }

  onLoad() {
    if (this.unmounting) return;

    this.setState({
      isScriptLoaded: true
    });

    if (!window.CKEDITOR) {
      console.error("CKEditor not found");
      return;
    }

    // window.CKEDITOR.replace(
    //   ReactDOM.findDOMNode(this),
    //   additionalConfig
    //   );

    this.editorInstance = window.CKEDITOR.appendTo(
      ReactDOM.findDOMNode(this),
      this.state.config,
      this.props.content
    );

    let lastEditor = Object.keys(window.CKEDITOR.instances);
    lastEditor = lastEditor[lastEditor.length - 1];

    window.CKEDITOR.instances[lastEditor].on("instanceReady", function () {
      window.CKEDITOR.instances[lastEditor].on("paste", function (ev) {
        var _html = ev.data.dataValue;

        //On paste, replace p => div
        var re = new RegExp("(<p)([^>]*>.*?)(<\/p>)", "gi");
        _html = _html.replace(re, "<div$2</div>");
        ev.data.dataValue = _html;
      });
    });


    //Register listener for custom events if any
    for (var event in this.props.events) {
      var eventHandler = this.props.events[event];

      this.editorInstance.on(event, eventHandler);
    }
    // window.CKEDITOR.replace('cke_editor1', additionalConfig);
  }

  render() {
    const { isScriptLoaded } = this.state;
    const { ckDefaultDiv } = this.props.classes;
    if (!isScriptLoaded) {
      return (<div className={ckDefaultDiv}></div>);
    }
    return <div className={`${this.props.activeClass}`} />;
  }
}


CKEditor.defaultProps = {
  content: "",
  config: {},
  isScriptLoaded: false,
  scriptUrl: defaultScriptUrl,
  activeClass: "",
  events: {}
};

CKEditor.propTypes = {
  content: PropTypes.any,
  config: PropTypes.object,
  isScriptLoaded: PropTypes.bool,
  scriptUrl: PropTypes.string,
  activeClass: PropTypes.string,
  events: PropTypes.object
};

export default injectSheet(ckEditorCss)(CKEditor);